angular.module('wbDashboard').controller('PlansDetailFeatureEditTaxpreferredaccountControllerAurea',
['$scope', '$uibModal', '$filter', 'NgTableParams', 'PlanService', 'User', 'Milestone', 'Message',
function ($scope, $uibModal, $filter, NgTableParams, PlanService, User, Milestone, Message) {

    //$scope.fundingStrategies //set in parent

    $scope.pageData.page = $scope.$stateParams.page;
    $scope.pageData.view = {footer: true};
    $scope.pages = ['strategy', 'auto-deposit-detail', 'auto-deposit-confirm-strategy', 'submit-strategy'];
    var pageIndex = $scope.pages.indexOf($scope.$stateParams.page);
    if (pageIndex>-1 && pageIndex !== 0) {
        //entered into strategy pages, but not on first page
        $scope.$state.go(".",{page:$scope.pages[0]});
    }

    Milestone.clearMS();
    $scope.milestone = Milestone.ms;
    $scope.MS = Milestone;


    $scope.objectLength = function(o) {
        return Object.keys(o).length;
    };

    $scope.$watch('retirement', function(retirement) {
        if (retirement) {
            Milestone.setMilestoneUpdateFromObject(retirement);
        }
    });

    $scope.$watch('milestone.accounts', function(accounts, oldAccounts) {
        Milestone.updateAutoDepositRemaining();
        Milestone.fixRemainingAutodeposits(accounts, oldAccounts);
        Milestone.updateAnnualLimits();
    }, true);

    $scope.updateLimits = function() {
        {
            $scope.pageData.sending = true;
            var data = {
                accounts: []
            };

            angular.forEach($scope.milestone.accounts, function(account) {
                if (account.type.includes('ira')) {
                    data.accounts.push({
                        account_number: account.account_number,
                        annual_deposit_limit: account.annual_deposit_limit
                    });
                }
            });

            PlanService.user.updateAnnualDepositLimits(data).catch(function(err) {
                Message.set({
                    text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                    type: "danger"
                });
                throw err;
            }).then(function() {
                angular.forEach(data.accounts, function(account) {
                    var overviewAccount = $filter('filter')(User.getOverview().account_overview, {account_number:account.account_number});
                    if (overviewAccount.length && overviewAccount[0].extra) {
                        //the calculated assist data would have changed if the annual limit did
                        delete overviewAccount[0].extra.assist;
                    }
                });

                return User.retrieveMilestones($scope.retirement.id, true);
            }).then(function() {
                Message.set({
                    text: "Your annual deposit limits have been updated.",
                    type: 'success'
                });
            }).finally(function() {
                $scope.pageData.sending = false;
                if ($scope.$stateParams.returnTo === "strategy") {
                    $scope.$state.go(".", {page:"strategy", returnTo:null});
                } else {
                    $scope.$state.go(".^");
                }
            });
        }
    };


    $scope.goNextPage = function() {
        var pageIndex = $scope.pages.indexOf($scope.$stateParams.page);
        var nextPage = null;
        switch ($scope.$stateParams.page) {
            case 'annual-limit':
                nextPage = "submit-limits";
                break;
            case 'strategy':
                break;
            default:
                break;
        }
        if (!nextPage) {
            nextPage = $scope.pages[pageIndex+1];
        }
        switch (nextPage) {
            case 'auto-deposit-detail':
                if ($scope.milestone.metadata.funding_strategy === 'calculated_waterfall') {
                    nextPage = 'submit-strategy';
                }
                break;
        }

        if (nextPage === 'submit-limits') {
            $scope.updateLimits();
        } else if (nextPage === 'submit-strategy') {
            $scope.updateStrategy();
        } else {
            $scope.goToPage(nextPage);
        }

    };
    $scope.goToPage = function(page) {
        if (page === 'auto-deposit-confirm') {
            page = 'auto-deposit-confirm-strategy';
        }
        $scope.$state.go(".",{page:page});
    };
    $scope.updateStrategy = function() {

        if ($scope.status.missingLimit) {
            $scope.goToEditStrategy();
            return;
        }

        $scope.pageData.sending = true;
        var data = Milestone.prepareSubmitData($scope.milestone);
        Milestone.update(data).catch(function(err) {
            Message.set({
                text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                type: "danger"
            });
            throw err;
        }).then(function() {
            return User.retrieveMilestones($scope.retirement.id, true);
        }).then(function() {
            Message.set({
                text: "Your funding strategy has been updated.",
                type: 'success'
            });
        }).finally(function() {
            $scope.pageData.sending = false;
            $scope.$state.go(".^", {'#':'edit'});
        });
    };


    var transitionDeregisterHook = $scope.$transitions.onSuccess({ to: $scope.$state.current.name+".**" }, function(trans) {
        $scope.pageData.page = trans.params('to').page;
        $scope.pageData.view.footer = true;
    });
    $scope.$on('$destroy', function() {
        if (transitionDeregisterHook) {
            transitionDeregisterHook();
        }
    });

}]);
